import './card.scss';

import { useGetUserPetProfiles } from 'hooks/useGetUserPetProfiles';
import { CarouselWrapper } from 'petdna-lib-uicomponents/components';
import React, { useCallback, useEffect, useMemo } from 'react';
import { SwiperClass } from 'swiper/react';

const preferableOrder = ['portrait_dark', 'portrait_light'];

type SocialSharingCarouselProps = {
  sharedImages: { [key: string]: string };
  setCurrentTemplate: React.Dispatch<React.SetStateAction<string | undefined>>;
};

const SocialSharingCarousel: React.FC<SocialSharingCarouselProps> = ({
  sharedImages,
  setCurrentTemplate,
}) => {
  useGetUserPetProfiles();

  const renderImageItem = useCallback(
    (imgUrl: string) => (
      <div className="d-flex justify-content-center">
        <img
          src={imgUrl}
          alt="Chart"
          className="img-fluid social-image-share"
        />
      </div>
    ),
    [],
  );

  const sharedImagesKeys = useMemo(() => {
    const keys = Object.keys(sharedImages) as string[];
    return preferableOrder.filter(
      (k) => keys.includes(k),
    );
  }, [sharedImages]);

  useEffect(() => {
    if (!sharedImagesKeys.length) return;
    setCurrentTemplate(sharedImagesKeys[0]);
  }, [sharedImagesKeys, setCurrentTemplate]);

  const onSlideChange = useCallback((swiper: SwiperClass) => {
    setCurrentTemplate(sharedImagesKeys[swiper.activeIndex]);
  }, [sharedImagesKeys, setCurrentTemplate]);

  return (
    <CarouselWrapper
      className="social-sharing-carousel"
      forceDisplayNavButtons
      onSlideChangeCallback={onSlideChange}
    >
      {sharedImagesKeys.map((key) => renderImageItem(sharedImages[key]))}
    </CarouselWrapper>
  );
};

export default SocialSharingCarousel;
